import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useSeo } from "@/lib/useSeo";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  useSeo({ title: "Blog — Guides & Product Updates", description: "Guides, tips and product updates from Kovi Tools.", path: "/blog" });
  useEffect(() => { axios.get(`${API}/blog`).then((r) => setPosts(r.data.posts || [])).catch(() => {}); }, []);
  return (
    <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8 animate-fade-up">
      <h1 className="font-heading text-4xl font-bold tracking-tight">Blog</h1>
      <p className="mt-2 text-muted-foreground">Guides, tips and updates from the Kovi Tools team.</p>
      <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
        {posts.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary/40 hover:shadow-lg">
            <span className="overline text-primary">{p.tag}</span>
            <h2 className="mt-2 font-heading text-xl font-bold group-hover:text-primary">{p.title}</h2>
            <p className="mt-2 text-sm text-muted-foreground">{p.excerpt}</p>
            <p className="mt-4 text-xs text-muted-foreground">{p.date}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Blog;
